export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Dlaczego <span className="text-accent-500 italic">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-sm text-foreground-500 mt-2">Poznaj zalety korzystania z uporządkowanej bazy produktów</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 max-w-6xl mx-auto">
          <div className="lg:col-span-2 relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20product%20arrangement%20of%20cream%20knit%20sweater%20draped%20over%20a%20light%20oak%20wooden%20stool%20next%20to%20a%20pair%20of%20white%20sneakers%20on%20warm%20sand%20colored%20floor%20soft%20natural%20light%20from%20large%20window%20creating%20gentle%20shadows%20scandinavian%20interior%20with%20white%20walls%20editorial%20fashion%20photography%20serene%20peaceful%20composition%20high%20detail%20film%20grain&width=800&height=1000&seq=feature-left-v2&orientation=portrait"
              alt="Kakobuy Spreadsheet – organizacja produktów"
              title="Kakobuy Finds – uporządkowane produkty"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/50 to-transparent">
              <span className="text-background-50 text-sm font-medium">Kakobuy Spreadsheet</span>
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-4">
            <div className="flex-1 relative rounded-2xl overflow-hidden h-[200px]">
              <img
                src="https://readdy.ai/api/search-image?query=Close%20up%20flat%20lay%20of%20elegant%20silver%20necklace%20and%20minimalist%20gold%20ring%20on%20soft%20dusty%20rose%20colored%20velvet%20fabric%20surface%20dramatic%20side%20lighting%20creating%20delicate%20metallic%20reflections%20and%20deep%20velvet%20texture%20editorial%20jewelry%20photography%20luxurious%20romantic%20aesthetic%20sophisticated%20composition%20high%20detail%20film%20grain&width=900&height=500&seq=feature-top-right-v2&orientation=landscape"
                alt="Kakobuy Finds – akcesoria"
                title="Kakobuy Spreadsheet – lista akcesoriów"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="flex-1 relative rounded-2xl overflow-hidden h-[200px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20product%20photography%20of%20a%20classic%20beige%20fedora%20hat%20resting%20on%20natural%20linen%20fabric%20surface%20soft%20afternoon%20sunlight%20coming%20from%20side%20creating%20gentle%20hat%20shadow%20editorial%20fashion%20accessory%20photography%20minimal%20composition%20earthy%20neutral%20tones%20calm%20aesthetic%20high%20detail%20film%20grain&width=900&height=500&seq=feature-bottom-right-v2&orientation=landscape"
                alt="Kakobuy Finds – nakrycia głowy"
                title="Kakobuy Spreadsheet – nakrycia głowy"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}